import React, { useState } from "react";
import { FaUser, FaLock, FaTimes, FaSignInAlt, FaPaperPlane, FaKey } from "react-icons/fa";
import { useNavigate } from "react-router-dom"; // استيراد التوجيه

const LoginModal = ({ isOpen, onClose, fieldUid, backEnd_request, savePublicLogin }) => {
    const navigate = useNavigate(); // دالة التنقل
    const [isResending, setIsResending] = useState(false);
    const [formData, setFormData] = useState({
        username: "",
        password: "",
    });
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: "", msg: "" });

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setStatus({ type: "info", msg: "جاري التحقق من البيانات..." });

        try {
            const response = await backEnd_request.post("/public/account/login", {
                username: formData.username,
                password: formData.password,
                fieldUid: fieldUid
            });

            // التأكد من أن السيرفر أعاد التوكن فعلياً
            const accountToken = response.data?.accountToken;

            if (accountToken) {
                // حفظ البيانات وتحديث الحالة
                savePublicLogin(response.data, fieldUid);
                setStatus({ type: "success", msg: "تم تسجيل الدخول بنجاح!" });

                // لا نحتاج لـ navigate هنا إذا كانت savePublicLogin تقوم بها
                // ولكن سننتظر قليلاً ليراها المستخدم
                setTimeout(() => {
                    onClose();
                }, 1000);
            } else {
                // إذا نجح الطلب لكن السيرفر لم يرسل توكن (حالة نادرة لكن ممكنة)
                setStatus({ type: "danger", msg: "اسم المستخدم أو كلمة المرور غير صحيحة." });
            }

        } catch (error) {
            console.error("Login Error:", error);

            // فحص نوع الخطأ القادم من السيرفر
            let errorMsg = "فشل الاتصال بالسيرفر، حاول لاحقاً.";

            if (error.response) {
                // السيرفر رد بكود خطأ (401, 400, 500...)
                if (error.response.status === 401 || error.response.status === 400) {
                    errorMsg = "بيانات الدخول غير صحيحة، يرجى المحاولة مرة أخرى.";
                } else {
                    errorMsg = error.response.data?.message || "حدث خطأ غير متوقع.";
                }
            }

            setStatus({ type: "danger", msg: errorMsg });

            // أهم خطوة: التأكد من عدم عمل navigate في حالة الخطأ
        } finally {
            setLoading(false);
        }
    };

    const handleResendPassword = async () => {
        if (!formData.username) {
            setStatus({ type: "warning", msg: "يرجى إدخال اسم المستخدم أولاً." });
            return;
        }

        setLoading(true);
        setStatus({ type: "info", msg: "جاري طلب إعادة إرسال كلمة المرور..." });

        try {
            await backEnd_request.post("/public/account/resend-password", {
                username: formData.username,
                fieldUid: fieldUid
            });
            setStatus({ type: "success", msg: "تم إرسال كلمة المرور إلى هاتفك المسجل عبر SMS." });
        } catch (error) {
            setStatus({ type: "danger", msg: "فشل الإرسال، تأكد من صحة اسم المستخدم المرتبط بهذه المنشأة." });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-glass-card shadow-lg" onClick={e => e.stopPropagation()}>
                <div className="modal-header-custom border-bottom pb-3 mb-4 d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-2">
                        <div className="icon-badge-blue">
                            {isResending ? <FaKey /> : <FaSignInAlt />}
                        </div>
                        <div>
                            <h5 className="fw-bold mb-0 text-dark">
                                {isResending ? "استعادة كلمة المرور" : "تسجيل دخول الى الفعالية"}
                            </h5>
                            <small className="text-muted">نافذة تسجيل الدخول</small>
                        </div>
                    </div>
                    <button className="btn-close-circle" onClick={onClose}><FaTimes /></button>
                </div>

                {status.msg && (
                    <div className={`alert alert-${status.type} py-2 small border-0 shadow-sm mb-3`}>
                        {loading && <span className="spinner-border spinner-border-sm ms-2"></span>}
                        {status.msg}
                    </div>
                )}

                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label className="form-label small fw-bold text-muted">اسم المستخدم</label>
                        <div className="input-group">
                            <span className="input-group-text bg-light border-0"><FaUser className="text-primary" /></span>
                            <input
                                name="username"
                                type="text"
                                className="form-control border-0 bg-light"
                                placeholder="أدخل اسم المستخدم"
                                required
                                value={formData.username}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {!isResending && (
                        <div className="mb-3">
                            <label className="form-label small fw-bold text-muted">كلمة المرور</label>
                            <div className="input-group">
                                <span className="input-group-text bg-light border-0"><FaLock className="text-primary" /></span>
                                <input
                                    name="password"
                                    type="password"
                                    className="form-control border-0 bg-light"
                                    placeholder="أدخل كلمة المرور"
                                    required
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    )}

                    <div className="d-grid gap-2 mt-4">
                        {!isResending ? (
                            <>
                                <button type="submit" className="btn btn-primary py-2 fw-bold" disabled={loading}>
                                    دخول للمنصة
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-link btn-sm text-decoration-none"
                                    onClick={() => { setIsResending(true); setStatus({ type: "", msg: "" }); }}
                                >
                                    نسيت كلمة المرور؟ أعد إرسالها لهاتفك
                                </button>
                            </>
                        ) : (
                            <>
                                <button
                                    type="button"
                                    className="btn btn-warning py-2 fw-bold"
                                    onClick={handleResendPassword}
                                    disabled={loading}
                                >
                                    <FaPaperPlane className="ms-2" /> إرسال كلمة المرور
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-link btn-sm text-decoration-none"
                                    onClick={() => { setIsResending(false); setStatus({ type: "", msg: "" }); }}
                                >
                                    العودة لتسجيل الدخول
                                </button>
                            </>
                        )}
                    </div>
                </form>
            </div>

            <style>{`
                .modal-overlay { position: fixed; top:0; left:0; width:100%; height:100%; background: rgba(15, 23, 42, 0.85); backdrop-filter: blur(8px); display: flex; justify-content: center; align-items: center; z-index: 2000; }
                .modal-glass-card { background: white; width: 92%; max-width: 400px; border-radius: 25px; padding: 30px; }
                .icon-badge-blue { width: 45px; height: 45px; background: #e0f2fe; color: #0284c7; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 1.2rem; }
                .input-group-text { border-radius: 12px 0 0 12px !important; }
                .form-control { border-radius: 0 12px 12px 0 !important; height: 45px; border: 1px solid #f1f5f9 !important; }
                .form-control:focus { box-shadow: none; border-color: #38bdf8 !important; background: white !important; }
                .btn-close-circle { border: none; background: #f1f5f9; border-radius: 50%; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; color: #64748b; }
            `}</style>
        </div>
    );
};

export default LoginModal;